import { blogPosts as generatedBlogPosts, type BlogPostSummary } from './blogPosts.generated';
import { blogPostDraftOverrides } from './blogPostDraftOverrides';

export type BlogPost = BlogPostSummary & {
  bodyHtml?: string;
};
export const blogPosts = [...generatedBlogPosts].sort(
  (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime(),
);

export const getBlogPostBySlug = (slug: string) => {
  const normalized = slug.startsWith('/post/') ? slug : `/post/${slug}`;
  const decoded = decodeURIComponent(normalized);

  return blogPosts.find((post) => {
    return post.slug === normalized || post.slug === decoded || decodeURIComponent(post.slug) === decoded;
  });
};

export const latestBlogPosts = blogPosts.slice(0, 2);

export const getBlogPostBodyBySlug = async (slug: string) => {
  const post = getBlogPostBySlug(slug);

  if (!post) {
    return undefined;
  }

  const draftOverride = blogPostDraftOverrides[post.slug];
  if (draftOverride) {
    return draftOverride;
  }

  const module = await import('./blogPostBodies.generated');
  return module.blogPostBodies[post.slug] || module.blogPostBodies[decodeURIComponent(post.slug)];
};
